import { r4Client, r4Error } from "@/services";

const DealerApi = {
  async fetchDealers() {
    try {
      const resp = await r4Client().get("/api/v1/dealers");
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
  async createDealer(dealerData) {
    try {
      const resp = await r4Client().post("/api/v1/dealers", dealerData);
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
  async updateDealer(dealerData) {
    try {
      const resp = await r4Client().put(
        `/api/v1/dealers/${dealerData.id}`,
        dealerData
      );
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
  // determines if create or update should be used
  async saveDealer(dealerData) {
    if (dealerData.id) {
      return this.updateDealer(dealerData);
    } else {
      return this.createDealer(dealerData);
    }
  },
  async getDealer(dealerData) {
    try {
      const resp = await r4Client().get(`/api/v1/dealers/${dealerData.id}`);
      return resp.data;
    } catch (error) {
      throw r4Error(error);
    }
  },
};

export default DealerApi;
